import { registerPlugin } from '@capacitor/core';

import { QuicknotesPlugingInterface } from './definitions';
import { CAPACITOR_QUICKNOTES_PLUGIN } from '../pluginConstants';

const QuicknotesPlugin = registerPlugin<QuicknotesPlugingInterface>(CAPACITOR_QUICKNOTES_PLUGIN);

export * from './definitions';
export { QuicknotesPlugin };
